export default "__VITE_ASSET__BVpd7U85__"